import React from 'react';
import Breadcrumb from '../Breadcrumb/Breadcrumb';
import Link from '../Link';
import backBtn from '../../Icons/backbtn.svg';

import * as styles from './heropage.module.scss';

function HeroPage({
  title,
  date = null,
  isDetailView = false,
  parentTitle = null,
  breadcrumb = null,
  children = null,
  breadcrumbDetail = null,
  backButton = false,
  applyTruncate = true,
  alignHeader = false,
  customHeaderRowCss = null,
  customHeaderColCss = null,
}) {
  return (
    <div id="egp-hero-page" className={styles.heroPage}>
      <div className="container">
        <div
          className={`${alignHeader && !customHeaderRowCss ? 'row justify-content-center' : ''} ${
            customHeaderRowCss ? customHeaderRowCss : ''
          }`}
        >
          <div
            className={`${alignHeader && !customHeaderColCss ? 'col-lg-9' : ''} ${
              customHeaderColCss ? customHeaderColCss : ''
            }`}
          >
            {breadcrumb && (
              <Breadcrumb items={breadcrumb} breadcrumbDetail={breadcrumbDetail} applyTruncate={applyTruncate} />
            )}

            {backButton && (
              <Link className={`${styles.backBtn}`} href={backButton}>
                <img src={backBtn} alt="Back button icon" />
                Back to search
              </Link>
            )}

            <div>
              {date && <div className={styles.heroDate}>{date}</div>}
              {parentTitle && <h2>{parentTitle}</h2>}
              {!parentTitle && <h1 className={`${styles.heroTitle} ${isDetailView ? styles.sm : ''}`}>{title}</h1>}

              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HeroPage;
